export default "__VITE_ASSET__ZG$Vgzsx__"